
import { Link } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface UserAvatarProps {
  avatar: string | null;
  name: string;
}

export function UserAvatar({ avatar, name }: UserAvatarProps) {
  const initials = name.split(' ').map(n => n[0]).join('');
  
  return (
    <Link to="/settings">
      <Avatar className="cursor-pointer hover:opacity-80 transition-opacity">
        {avatar ? (
          <AvatarImage 
            src={avatar} 
            alt={name}
            className="object-cover w-full h-full"
          />
        ) : null}
        <AvatarFallback className="bg-white/10 text-white">{initials}</AvatarFallback>
      </Avatar>
    </Link>
  );
}
